import { latestDataPointGroupUpdateDate, latestDataPointGroupUpdateDateTime } from '../../DataPointGroup';
import { decayedLimit, isDecayed } from '../../util';
import { AmountSumTableItem, AmountSumTableItemProps } from './Table';
import { Business } from '../../generated/graphql';

export interface BusinessSumTableItemProps
  extends Pick<
    AmountSumTableItemProps,
    'amount' | 'className' | 'subtitle' | 'withChevron' | 'contentPrefix' | 'motionProps'
  > {
  itemTitle?: string;
  business: Business;
  onItemClicked?: (a: { business: Business }) => void;
}

export const BusinessSumTableItem = ({ business, onItemClicked, ...props }: BusinessSumTableItemProps) => {
  return (
    <AmountSumTableItem
      contentPrefix={props.contentPrefix}
      motionProps={props.motionProps}
      key={business.id}
      title={props.itemTitle ?? business.name}
      dataTestID={business.name}
      withChevron={props.withChevron ?? !!onItemClicked}
      amount={business.ownedValue}
      className={props.className}
      subtitle={props.subtitle}
      onClick={() => onItemClicked?.({ business })}
      lastUpdated={latestDataPointGroupUpdateDateTime(business.value)}
      onKeyDown={(e) => e.key === 'Enter' && onItemClicked?.({ business })}
      decayed={isDecayed(latestDataPointGroupUpdateDate(business.value), decayedLimit.Business)}
    />
  );
};
